import { PROFILE_OGA, PROFILE_SISTEMAS } from "../data/profiles";

class AudienceService {
    //Verifica si tiene defensa oficial
    hasDefensaOficial(audience){
        let response = false;
        //Me fijo si hay imputados
        if(audience.imputadoList && audience.imputadoList.length > 0){
            //Recorro cada imputado
            audience.imputadoList.map(accused => {
                //Si hay defensoria
                if(accused.defensoria){
                    //Retorno
                    response = true;
                }
            })
        }
        //Me fijo si hay victimas
        if(audience.victimaList && audience.victimaList.length > 0){
            //Recorro cada victima
            audience.victimaList.map(victim => {
                //Si hay defensoria
                if(victim.defensoria){
                    //Retorno
                    response = true;
                }
            })
        }
        //Por defecto retorno false
        return response;
    }
    //Verifica si tiene defensa particular
    hasDefensaParticular(audience){
        let response = false;
        //Me fijo si hay imputados
        if(audience.imputadoList && audience.imputadoList.length > 0){
            //Recorro cada imputado
            audience.imputadoList.map(accused => {
                //Si hay particular
                if(accused.imputadoParticularesList && accused.imputadoParticularesList.length > 0){
                    //Retorno
                    response = true;
                }
            })
        }
        //Me fijo si hay victimas
        if(audience.victimaList && audience.victimaList.length > 0){
            //Recorro cada victima
            audience.victimaList.map(victim => {
                //Si hay particular
                if(victim.victimaParticularesList && victim.victimaParticularesList.length > 0){
                    //Retorno
                    response = true;
                }
            })
        }
        //Por defecto retorno false
        return response;
    }
    //Verifica si tiene defensa menores
    hasDefensaMenores(audience){
        let response = false;
        //Me fijo si hay imputados
        if(audience.imputadoList && audience.imputadoList.length > 0){
            //Recorro cada imputado
            audience.imputadoList.map(accused => {
                //Si hay defensoria
                if(accused.menores){
                    //Retorno
                    response = true;
                }
            })
        }
        //Me fijo si hay victimas
        if(audience.victimaList && audience.victimaList.length > 0){
            //Recorro cada imputado
            audience.victimaList.map(victim => {
                //Si hay defensoria
                if(victim.defensoria && victim.defensoria.menor===1){
                    //Retorno
                    response = true;
                }
            })
        }
        //Por defecto retorno false
        return response;
    }
    //Privado de libertad
    isPrivadoLibertad(audience){
        let response = false;
        //Me fijo si hay imputados
        if(audience.imputadoList && audience.imputadoList.length > 0){
            //Recorro cada imputado
            audience.imputadoList.map(accused => {
                //Si hay defensoria
                if(accused.detenido === 1){
                    //Retorno
                    response = true;
                }
            })
        }
        //Por defecto retorno false
        return response;
    }

    //Validación de Imputado
    isAccusedValid(accused){
        //Persona
        if(!accused.persona){
            //No es válido
            return false;
        }
        //Verifico el apellido
        if(!accused.persona.apellido || accused.persona.apellido.trim() === ''){
            //No es válido
            return false;
        }
        //Verifico el nombre
        if(!accused.persona.nombre || accused.persona.nombre.trim() === ''){
            //No es válido
            return false;
        }
        if(!accused.persona.tipo_documento || accused.persona.tipo_documento.trim() === ''){
            //No es válido
            return false;
        }
        if(!accused.persona.nro_documento || accused.persona.nro_documento.trim() === ''){
            //No es válido
            return false;
        }
        if(!accused.domicilio || accused.domicilio.trim() === ''){
            //No es válido
            return false;
        }
        if(typeof accused.menor === "undefined" || (parseInt(accused.menor) !== 0 && parseInt(accused.menor) !== 1)){
            //No es válido
            return false;
        }
        if(typeof accused.detenido === "undefined" || (parseInt(accused.detenido) !== 0 && parseInt(accused.detenido) !== 1)){
            //No es válido
            return false;
        }
        //Por defecto es válido
        return true;
    }

    //Validación de Víctima
    isVictimValid(victim){
        //Persona
        if(!victim.persona){
            //No es válido
            return false;
        }
        //Verifico el apellido
        if(!victim.persona.apellido || victim.persona.apellido.trim() === ''){
            //No es válido
            return false;
        }
        //Verifico el nombre
        if(!victim.persona.nombre || victim.persona.nombre.trim() === ''){
            //No es válido
            return false;
        }
        if(!victim.persona.tipo_documento || victim.persona.tipo_documento.trim() === ''){
            //No es válido
            return false;
        }
        if(!victim.persona.nro_documento || victim.persona.nro_documento.trim() === ''){
            //No es válido
            return false;
        }
        if(typeof victim.menor === "undefined" || (parseInt(victim.menor) !== 0 && parseInt(victim.menor) !== 1)){
            //No es válido
            return false;
        }
        if(typeof victim.querellante === "undefined" || (parseInt(victim.querellante) !== 0 && parseInt(victim.querellante) !== 1)){
            //No es válido
            return false;
        }
        //Por defecto es válido
        return true;
    }

    getInvenietLink(audience){
        //Armo el link
        const host = process.env.REACT_APP_INVENIET_API_HOST;
        const prefix = process.env.REACT_APP_INVENIET_PREFIX;
        //Retorno
        return `${host}inveniet/?token=YWRtaW46QXVkaW9pbXBvcnQ0NTA=&consumerUUID=${prefix}${audience.id}`;
    }

    // ==========================================================================================
    // Tareas #14593 ----------------------------------------------------------------------------
    // ==========================================================================================
    canOpen(audience, user){
        //Me fijo que no sea privada
        if(audience.privada === 0){
            return true;
        }
        //Verifico por perfil
        if(user.perfil.id===PROFILE_SISTEMAS || user.perfil.id===PROFILE_OGA )
        {
            //Si es OGA o Sistemas, verifico que tenga permiso para privadas o que sea el operador
            if( user.privadas===1 || ( audience.operador && user.id===audience.operador.id ) ){
                //Muestra el botón cuando el usuario tiene acceso a las reservadas o cuando es el operador
                return true; 
            }else{
                //No debo mostar el botón
                return false;
            }
        }else{   
             //El usuario no es OGA ni Sistemas entonces muestra siempre el botón
            return true;
        }
    }

    hasAccess(audience, user){
        /*
        //Si es perfil Sistema
        if(user.perfil.id === PROFILE_SISTEMAS){
            return true;
        }
        //Me fijo que no sea privada
        if(audience.privada === 0){
            return true;
        }
        //Me fijo si el usuario tiene acceso a las reservadas
        if(user.privadas === 1){
            return true;
        }
        //Me fijo el perfil
        if(user.perfil.id === PROFILE_OGA){
            //Me fijo si es operador
            // if(user.id === audience.operador.id){
            //     return true;
            // }
        }
        //Me fijo si es operador
        if(audience.operador && audience.operador.id === user.id){
            //Otorgo acceso, no importa lo demás
            return true;
        }
        //Retorno
        return false;
        */
       if( audience.privada===0 )
       {    return true; //Muestra los botones cuando la audiencia no es privada
       }
       else
       {    if( user.privadas===1 || ( audience.operador && user.id===audience.operador.id ) )
            {   return true; //Muestra los botones cuando el usuario tiene acceso a las reservadas o cuando es el operador
            }
            else
            {   return false;
            }
       }
    }
    // ==========================================================================================
    // Tareas #14593 ----------------------------------------------------------------------------
    // ==========================================================================================
}

export default new AudienceService();